<div>
  @if (sectionName) {
    <div class="section">{{sectionName}}</div>
  }
  @if (safeTitle) {
    <div class="title" [innerHtml]="safeTitle"></div>
  }
</div>